import { render } from "./Patient_PersonalData.vue?vue&type=template&id=306dbabf"
import script from "./Patient_PersonalData.vue?vue&type=script&lang=js"
export * from "./Patient_PersonalData.vue?vue&type=script&lang=js"

import "./Patient_PersonalData.vue?vue&type=style&index=0&id=306dbabf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__